import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru';

/**
 * i18next bootstrap. RU is the only shipped locale (ST13), bundled inline — no async
 * backend, no locale fetched over the network, so strings are ready synchronously
 * before the first render and the page needs nothing from any host.
 *
 * Single default namespace `portal`, matching the captive portal's shape.
 */
export const defaultNS = 'portal';

export const resources = {
  ru: { portal: ru },
} as const;

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: 'ru',
    fallbackLng: 'ru',
    defaultNS,
    ns: ['portal'],
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export default i18n;
